export interface InfoState {
  browserName?: string
  browserVersion?: string
  osIanaTimezone: string
  appLanguage: string
  osTimezone: number
  appVersion: string
}

export const BatchStatusCssClasses = new Map<string, string>([
  ['success', 'success'],
  ['error', 'warning'],
  ['fail', 'danger'],
])
export const BatchStatusTitles = new Map<string, string>([
  ['success', 'Completado'],
  ['error', 'Con errores'],
  ['fail', 'Fallido'],
])

export const textColors = new Map<string, string>([
  ['primary', 'text-primary'],
  ['primary-dark', 'text-primary-dark'],
  ['success', 'text-success'],
  ['warning', 'text-warning'],
  ['danger', 'text-danger'],
  ['light', 'text-light'],
  ['light-primary', 'text-light-primary'],
])

export interface ResponsePageProperties {
  currentPage: number
  pageSize: number
  previousPage: number
  nextPage: number
  totalPages: number
}
